
/**
 * Type of investment transaction.
 * @see "Section 13.9.2.4.4, OFX Spec"
 */
export enum InvestmentTransactionType {

  BUY_DEBT,
  BUY_MUTUAL_FUND,
  BUY_OPTION,
  BUY_OTHER,
  BUY_STOCK,
  CLOSE_OPTION,
  INCOME,
  INVESTMENT_EXPENSE,
  JOURNAL_FUND,
  JOURNAL_SECURITY,
  MARGIN_INTEREST,
  REINVEST_INCOME,
  RETURN_OF_CAPITAL,
  SELL_DEBT,
  SELL_MUTUAL_FUND,
  SELL_OPTION,
  SELL_OTHER,
  SELL_STOCK,
  SPLIT,
  TRANSFER
}
